import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from 'components/Button';
import VideoPlayer from './create/VideoPlayer';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 720,
    margin: 'auto',
  },
}));

const PlayModal = ({ video, onClose }) => {
  const classes = useStyles();
  return (
    <Dialog open fullWidth maxWidth="md">
      <DialogContent>
        <Box className={classes.root}>
          <VideoPlayer
            video_url={video.video_url}
            thumbnail_url={video.thumbnail_url}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlayModal;
